__turbopack_context__.v({
  "communityButton": "Button-module__l1L0ga__communityButton",
  "controlButton": "Button-module__l1L0ga__controlButton",
  "coral": "Button-module__l1L0ga__coral",
  "filterButton": "Button-module__l1L0ga__filterButton",
  "fullWidth": "Button-module__l1L0ga__fullWidth",
  "inner": "Button-module__l1L0ga__inner",
  "loading": "Button-module__l1L0ga__loading",
  "loadingSpinner": "Button-module__l1L0ga__loadingSpinner",
  "purple": "Button-module__l1L0ga__purple",
  "radioButton": "Button-module__l1L0ga__radioButton",
  "root": "Button-module__l1L0ga__root",
  "selected": "Button-module__l1L0ga__selected",
});
